
import { Product } from "@/types/product";

export const vpxTC1PRO: Product = {
  id: "vpx-tc1-pro",
  groupId: "avoip",
  name: "VPX-TC1-PRO",
  subtitle: "1Gb Box Transceiver",
  description: "The VPX-TC1-PRO is a professional-grade 1G AV over IP Transmitter that utilizes Aurora's advanced Mimix™ CODEC technology for superior video quality. This flagship model delivers pristine 4K60 4:4:4 video over standard 1G networks with zero frame latency, making it ideal for demanding professional installations.\n\nBuilt for reliability and performance, the PRO version includes enhanced features like redundant power options (PoE and local power), professional-grade components, and advanced system monitoring capabilities. The unit offers seamless integration with existing infrastructure and provides comprehensive control options including RS-232, IR, web GUI, and API control.\n\nThe VPX-TC1-PRO excels in mission-critical environments where reliability and performance are paramount, such as command and control centers, broadcast facilities, and high-end corporate installations.",
  features: [
    "Configure as Encoder or Decoder",
    "4K60 4:4:4 UHD 120m over 1G CAT 5e",
    "Zero Frame Latency (1.78ms)",
    "HDMI 2.0b, HDCP 2.2",
    "HDR10, HDR10+, Dolby Vision",
    "LPCM up to 12-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio & ATMOS",
    "12 bits color depth processing, 16bits OSD",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Low Power Fanless Design",
    "Scaling & Seamless Switching",
    "MJPEG Preview up to 720p30",
    "Video Wall with Image Rotation",
    "1G LAN PoE and SFP for Fiber or 2nd RJ-45",
    "2 HDMI Inputs, 1 HDMI Output",
    "Line In/Out Stereo",
    "RS-232 Serial Port and IR (In/Out)",
    "Channel Mapping with On-Screen Preview",
    "Integrated Web Server for Configuration",
    "USB 2.0 Ports for Cameras, HID Devices, Mass Storage, etc.",
    "AES67 Included",
    "Dante® 2 Ch Audio License Option",
    "Rack and Under Table Mounting"
  ],
  specifications: [
    "Compression: Mimix™ 13:1",
    "Latency: 0 Frame (1.78ms) with Ultra Low Latency Mode",
    "HDMI Inputs: 2 (HDMI 2.0b, HDCP 2.2)",
    "HDMI Outputs: 1 (HDMI 2.0b, HDCP 2.2)",
    "Encryption: AES 256",
    "Analog Audio: Stereo Line In/Out (3.5mm TRS)",
    "1G Ethernet: RJ-45 and SFP",
    "LAN: RJ-45 10/100/1000 PoE",
    "Video Bandwidth: 600MHz",
    "Video Support: Up to 4K2K 4:4:4 @ 60Hz",
    "Audio Support: Up to 12 Channels",
    "RS-232: Up to 115k Baud (3.5mm TRS)",
    "IR: Bi-Directional (3.5mm TRS)",
    "USB Connector: 1 USB 2.0 Type C, 1 USB 1.1 Type C, 1 USB 2.0 Type A, 2 USB 1.1 Type A",
    "Options: Dante® 2Ch License",
    "Interface: IR or Keyboard via OSD, Web Server",
    "Housing: Black Aluminum Enclosure",
    "Dimensions: 177.04 x 150.7 x 26.42mm [6.97\" x 5.93\" x 1.04\"]",
    "Weight: .453kg [1lbs]",
    "Mounting: Optional: Rack Mount Vertical, Rack Mount Horizontal, Under Table Mount",
    "Power Supply: 48v DC (2 Pin Euro) or PoE+ (LAN)",
    "Power Consumption: 8 Watts, up to 12.9 Watts with USB",
    "Operating Temperature: 0~40o C [32~104o F]",
    "Storage Temperature: -20~60o C [-4~140o F]",
    "Relative Humidity: 20~90% RH [No Condensation]",
    "Package Contents: 1x VPX-TC1, 2x Mounting Ears"
  ],
  images: [
    "/lovable-uploads/e8500a1d-5302-47ed-bdd1-04ee471cfdda.png",
    "/lovable-uploads/db25ccae-aff9-47a9-9a9d-d601c20b6f44.png",
    "/lovable-uploads/e558ec08-1a78-4116-9b0d-2bcb04311c62.png"
  ],
  videoUrl: "https://youtu.be/dAolV2vTp9c?si=KpcEs38V7Kl8rVVe",
  applicationDiagram: "/lovable-uploads/VPX-TC1-Pro_Application_Diagram.png",
  slug: "vpx-tc1-pro",
  networkSpeed: "1gb"
};
